export var RegisteredApplications;
(function (RegisteredApplications) {
    RegisteredApplications["APP_ADMIN"] = "app_admin";
    RegisteredApplications["APP_ONU_MAIN"] = "app_onu_main";
    RegisteredApplications["LIB_ONU_UI"] = "lib_onu_ui";
    RegisteredApplications["APP_AM_MAIN"] = "app_am_main";
    RegisteredApplications["APP_AM_ASSET_UPLOAD"] = "app_am_asset_upload";
    RegisteredApplications["UNREGISTERED"] = "unregistered";
})(RegisteredApplications || (RegisteredApplications = {}));
export var Applications;
(function (Applications) {
    Applications["Plant"] = "Plant";
    Applications["Insight"] = "Insight";
    Applications["Asset"] = "Asset";
})(Applications || (Applications = {}));
export const ProductsIdentifiers = {
    [Applications.Asset]: 'INF360A',
    [Applications.Insight]: 'INF360I',
    [Applications.Plant]: 'INF360P',
};
